import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { SetLogo } from '@sorare/core/src/atoms/icons/SetLogo';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandS, BrandXS } from '@sorare/core/src/atoms/typography';
import { Trapezoid } from '@sorare/core/src/atoms/ui/Trapezoid';

type Props = { title?: ReactNode };
export const SeriesOnboardingHeader = ({ title }: Props) => {
  return (
    <Vertical center gap={3}>
      <Vertical center gap={1.5}>
        <Trapezoid>
          <BrandXS color="var(--c-black)">
            <FormattedMessage defaultMessage="New Set" />
          </BrandXS>
        </Trapezoid>
        <SetLogo style={{ height: '48px' }} />
      </Vertical>
      {!!title && <BrandS>{title}</BrandS>}
    </Vertical>
  );
};
